/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Share_Selected_CountInputs */

const en_team_share_selected_count = /** @type {(inputs: Team_Share_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const fr_team_share_selected_count = /** @type {(inputs: Team_Share_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const de_team_share_selected_count = /** @type {(inputs: Team_Share_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const it_team_share_selected_count = /** @type {(inputs: Team_Share_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const ru_team_share_selected_count = /** @type {(inputs: Team_Share_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const es_team_share_selected_count = /** @type {(inputs: Team_Share_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const zh_cn2_team_share_selected_count = /** @type {(inputs: Team_Share_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const ja_team_share_selected_count = /** @type {(inputs: Team_Share_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const hi_team_share_selected_count = /** @type {(inputs: Team_Share_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const pt_pt2_team_share_selected_count = /** @type {(inputs: Team_Share_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Team_Share_Selected_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_selected_count = /** @type {((inputs: Team_Share_Selected_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Selected_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_selected_count(inputs)
	if (locale === "de") return de_team_share_selected_count(inputs)
	if (locale === "it") return it_team_share_selected_count(inputs)
	if (locale === "ru") return ru_team_share_selected_count(inputs)
	if (locale === "es") return es_team_share_selected_count(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_selected_count(inputs)
	if (locale === "ja") return ja_team_share_selected_count(inputs)
	if (locale === "hi") return hi_team_share_selected_count(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_selected_count(inputs)
	return en_team_share_selected_count(inputs)
});